import type { DataServiceResponse } from "@p2l/data-service";

import type { FeedbackModel, SuggestionModel } from "models";
import { frontpageHttpService, guideHttpService } from "./http-service";

const apiVersion = "1";
const url = `api/v${apiVersion}`;
const feedbackUrl = `${url}/feedback`;
const suggestionUrl = `${url}/suggestions`;

export async function sendFeedback(
  feedback: FeedbackModel
): Promise<DataServiceResponse<void>> {
  return await frontpageHttpService.post(`${feedbackUrl}/send`, feedback);
}

export async function sendSuggestion(
  suggestion: SuggestionModel
): Promise<DataServiceResponse<void>> {
  return await guideHttpService.post(`${suggestionUrl}`, suggestion);
}
